export default __webpack_public_path__ + "static/5 - Elavult biztosítéktábla cseréje-c848561c330baab2dd88d7bffe97ec75.jpg";